import React from 'react';
import Layout from '../layout/Layout';
import './LegalPage.css';

const AGB = () => {
  return (
    <Layout>
      <div className="legal-page">
        <div className="legal-container">
          <h1 className="legal-title">Allgemeine Geschäftsbedingungen (AGB)</h1>
        <p className="legal-updated">Stand: 17. Dezember 2024</p>

        <section className="legal-section">
          <h2>1. Geltungsbereich</h2>
          <p>
            Diese Allgemeinen Geschäftsbedingungen (AGB) gelten für alle Verträge zwischen der ANTICIPATER GmbH, 
            Alter Schlachthof 39, 76131 Karlsruhe (nachfolgend "Anbieter") und ihren Kunden (nachfolgend "Kunde") 
            über die Nutzung der Software-as-a-Service-Lösung ShapeGirls (nachfolgend "Software" oder "Dienst").
          </p>
        </section>

        <section className="legal-section">
          <h2>2. Vertragsgegenstand</h2>
          <p>
            <strong>2.1.</strong> Der Anbieter stellt dem Kunden die Software ShapeGirls zur Verfügung, eine 
            cloudbasierte Lösung für personalisierte Fitness- und Ernährungspläne.
          </p>
          <p>
            <strong>2.2.</strong> Der Funktionsumfang der Software ergibt sich aus der jeweils gewählten 
            Leistungsstufe und der aktuellen Produktbeschreibung auf der Website des Anbieters.
          </p>
          <p>
            <strong>2.3.</strong> Der Anbieter ist berechtigt, die Software weiterzuentwickeln und zu verbessern. 
            Wesentliche Änderungen, die den vertraglich vereinbarten Funktionsumfang beeinträchtigen, werden dem 
            Kunden rechtzeitig mitgeteilt.
          </p>
        </section>

        <section className="legal-section">
          <h2>3. Vertragsschluss und Laufzeit</h2>
          <p>
            <strong>3.1.</strong> Der Vertrag kommt durch die Registrierung des Kunden und die Bestätigung durch 
            den Anbieter zustande.
          </p>
          <p>
            <strong>3.2.</strong> Die Mindestvertragslaufzeit beträgt 1 Monat, sofern nicht anders vereinbart. 
            Der Vertrag verlängert sich automatisch um jeweils 1 Monat, wenn er nicht mit einer Frist von 7 
            Tagen zum Ende der Laufzeit gekündigt wird.
          </p>
          <p>
            <strong>3.3.</strong> Das Recht zur außerordentlichen Kündigung aus wichtigem Grund bleibt unberührt.
          </p>
        </section>

        <section className="legal-section">
          <h2>4. Leistungsumfang und Verfügbarkeit</h2>
          <p>
            <strong>4.1.</strong> Der Anbieter stellt die Software über das Internet zur Verfügung. Die 
            Verfügbarkeit beträgt durchschnittlich 99,5% im Jahresmittel, ausgenommen geplante Wartungsarbeiten.
          </p>
          <p>
            <strong>4.2.</strong> Wartungsarbeiten werden in der Regel außerhalb der üblichen Geschäftszeiten 
            (Mo-Fr, 8-18 Uhr) durchgeführt und dem Kunden rechtzeitig angekündigt.
          </p>
          <p>
            <strong>4.3.</strong> Der Anbieter ist berechtigt, Dritte (Subunternehmer) zur Leistungserbringung 
            einzusetzen.
          </p>
        </section>

        <section className="legal-section">
          <h2>5. Pflichten des Kunden</h2>
          <p>
            <strong>5.1.</strong> Der Kunde ist verpflichtet, die Software nur im Rahmen der gesetzlichen 
            Bestimmungen und dieser AGB zu nutzen.
          </p>
          <p>
            <strong>5.2.</strong> Der Kunde ist für die Sicherheit seiner Zugangsdaten verantwortlich und hat 
            diese vor dem Zugriff Dritter zu schützen.
          </p>
          <p>
            <strong>5.3.</strong> Der Kunde verpflichtet sich, regelmäßige Datensicherungen durchzuführen oder 
            durchführen zu lassen.
          </p>
          <p>
            <strong>5.4.</strong> Der Kunde ist verpflichtet, den Anbieter unverzüglich über erkannte Mängel oder 
            Sicherheitsvorfälle zu informieren.
          </p>
        </section>

        <section className="legal-section">
          <h2>6. Vergütung und Zahlungsbedingungen</h2>
          <p>
            <strong>6.1.</strong> Die Vergütung richtet sich nach der jeweils gewählten Leistungsstufe und den 
            aktuellen Preisen auf der Website des Anbieters.
          </p>
          <p>
            <strong>6.2.</strong> Die Abrechnung erfolgt monatlich oder jährlich im Voraus, je nach gewähltem 
            Zahlungsmodell.
          </p>
          <p>
            <strong>6.3.</strong> Zahlungen sind innerhalb von 14 Tagen nach Rechnungsstellung fällig.
          </p>
          <p>
            <strong>6.4.</strong> Bei Zahlungsverzug ist der Anbieter berechtigt, den Zugang zur Software zu 
            sperren.
          </p>
        </section>

        <section className="legal-section">
          <h2>7. Datenschutz und Datensicherheit</h2>
          <p>
            <strong>7.1.</strong> Der Anbieter verarbeitet personenbezogene Daten im Auftrag des Kunden gemäß den 
            Bestimmungen der DSGVO.
          </p>
          <p>
            <strong>7.2.</strong> Die Einzelheiten der Datenverarbeitung sind in einem separaten 
            Auftragsverarbeitungsvertrag (AVV) geregelt.
          </p>
          <p>
            <strong>7.3.</strong> Der Anbieter trifft angemessene technische und organisatorische Maßnahmen zum 
            Schutz der Daten.
          </p>
          <p>
            <strong>7.4.</strong> Die Daten werden ausschließlich in Rechenzentren innerhalb der Europäischen 
            Union gespeichert.
          </p>
        </section>

        <section className="legal-section">
          <h2>8. Gewährleistung</h2>
          <p>
            <strong>8.1.</strong> Der Anbieter gewährleistet, dass die Software im Wesentlichen die vertraglich 
            vereinbarten Funktionen erfüllt.
          </p>
          <p>
            <strong>8.2.</strong> Mängel werden vom Anbieter nach Mängelanzeige durch den Kunden innerhalb 
            angemessener Frist behoben.
          </p>
          <p>
            <strong>8.3.</strong> Die Gewährleistung umfasst nicht Mängel, die auf unsachgemäßer Nutzung, 
            Änderungen durch den Kunden oder höhere Gewalt beruhen.
          </p>
        </section>

        <section className="legal-section">
          <h2>9. Haftung</h2>
          <p>
            <strong>9.1.</strong> Der Anbieter haftet unbeschränkt für Vorsatz und grobe Fahrlässigkeit sowie für 
            Schäden aus der Verletzung des Lebens, des Körpers oder der Gesundheit.
          </p>
          <p>
            <strong>9.2.</strong> Bei leichter Fahrlässigkeit haftet der Anbieter nur bei Verletzung wesentlicher 
            Vertragspflichten (Kardinalpflichten). Die Haftung ist in diesem Fall auf den vertragstypischen, 
            vorhersehbaren Schaden begrenzt.
          </p>
          <p>
            <strong>9.3.</strong> Die Haftung für Datenverlust ist auf den typischen Wiederherstellungsaufwand 
            beschränkt, der bei regelmäßiger Datensicherung durch den Kunden entstanden wäre.
          </p>
          <p>
            <strong>9.4.</strong> Die Haftungsbeschränkungen gelten nicht bei Ansprüchen nach dem 
            Produkthaftungsgesetz.
          </p>
        </section>

        <section className="legal-section">
          <h2>10. Geheimhaltung</h2>
          <p>
            <strong>10.1.</strong> Beide Parteien verpflichten sich, alle im Rahmen der Vertragsbeziehung 
            erlangten vertraulichen Informationen geheim zu halten.
          </p>
          <p>
            <strong>10.2.</strong> Diese Verpflichtung besteht auch nach Beendigung des Vertrages fort.
          </p>
        </section>

        <section className="legal-section">
          <h2>11. Rechte an der Software</h2>
          <p>
            <strong>11.1.</strong> Alle Rechte an der Software verbleiben beim Anbieter. Dem Kunden wird lediglich 
            ein nicht ausschließliches, nicht übertragbares Nutzungsrecht für die Vertragslaufzeit eingeräumt.
          </p>
          <p>
            <strong>11.2.</strong> Der Kunde ist nicht berechtigt, die Software zu vervielfältigen, zu bearbeiten 
            oder Dritten zugänglich zu machen.
          </p>
        </section>

        <section className="legal-section">
          <h2>12. Beendigung des Vertrages</h2>
          <p>
            <strong>12.1.</strong> Bei Vertragsbeendigung wird der Zugang zur Software gesperrt.
          </p>
          <p>
            <strong>12.2.</strong> Der Kunde hat das Recht, seine Daten innerhalb von 30 Tagen nach Vertragsende 
            zu exportieren.
          </p>
          <p>
            <strong>12.3.</strong> Nach Ablauf dieser Frist werden die Kundendaten unwiderruflich gelöscht.
          </p>
        </section>

        <section className="legal-section">
          <h2>13. Änderungen der AGB</h2>
          <p>
            <strong>13.1.</strong> Der Anbieter ist berechtigt, diese AGB mit einer Ankündigungsfrist von 6 Wochen 
            zu ändern.
          </p>
          <p>
            <strong>13.2.</strong> Widerspricht der Kunde den Änderungen nicht innerhalb von 4 Wochen nach Zugang 
            der Änderungsmitteilung, gelten die geänderten AGB als akzeptiert.
          </p>
          <p>
            <strong>13.3.</strong> Der Anbieter wird den Kunden in der Änderungsmitteilung auf das Widerspruchsrecht 
            und die Bedeutung der Widerspruchsfrist hinweisen.
          </p>
        </section>

        <section className="legal-section">
          <h2>14. Schlussbestimmungen</h2>
          <p>
            <strong>14.1.</strong> Es gilt das Recht der Bundesrepublik Deutschland unter Ausschluss des 
            UN-Kaufrechts.
          </p>
          <p>
            <strong>14.2.</strong> Erfüllungsort und ausschließlicher Gerichtsstand ist Karlsruhe, sofern der 
            Kunde Kaufmann, juristische Person des öffentlichen Rechts oder öffentlich-rechtliches Sondervermögen 
            ist.
          </p>
          <p>
            <strong>14.3.</strong> Sollten einzelne Bestimmungen dieser AGB unwirksam sein oder werden, bleibt die 
            Wirksamkeit der übrigen Bestimmungen unberührt.
          </p>
          </section>
        </div>
      </div>
    </Layout>
  );
};

export default AGB;
